module.exports = __webpack_public_path__ + "static/media/banner1.27b67837.png";